import type { MutationTree } from 'vuex';
import type { EmergingThreatListWithSupplierResponseItem } from '@/modules/emerging-threats-clients/api';

const initialState = () => ({
  emergingThreats: [] as EmergingThreatListWithSupplierResponseItem[],
});

export const defaultState = initialState();
export type EmergingThreatsCommonState = typeof defaultState;

export const mutations: MutationTree<EmergingThreatsCommonState> = {
  SET_EMERGING_THREATS(state, data: EmergingThreatListWithSupplierResponseItem[]) {
    for (const et of data) {
      const ind = state.emergingThreats.findIndex((item) => item.id === et.id);
      if (ind > -1) {
        state.emergingThreats.splice(ind, 1, et);
      } else {
        state.emergingThreats.push(et);
      }
    }
  },
  CLEAR_STATE(state) {
    Object.assign(state, initialState());
  },
};
